import { render, staticRenderFns } from "./EventPeriod.vue?vue&type=template&id=2a71e0ea"
import script from "./EventPeriod.vue?vue&type=script&lang=js"
export * from "./EventPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports